import classNames from 'classnames'
import { FormikProps } from 'formik'
import { useModalControl } from '../../hooks/useModalControl'
import {
  CreateProductValues,
  Product,
} from '../../redux-toolkits/products/products.type'
import { EditInput } from '../inputs/editInput'
import { ProductGiftingModal } from '../modal/app_modals/productGiftingModal'
import { HeaderSubheader } from '../typography/HeaderSubheader'

export const ManageProductAsGift = ({
  formik,
  className,
  typeTitle,
  product,
  refetch,
}: {
  formik: FormikProps<CreateProductValues>
  className?: string
  typeTitle: string
  product?: Product
  refetch: () => void
}) => {
  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl()

  return (
    <>
      <div
        className={classNames(
          'flex flex-col gap-6 pb-10 border-b border-divider-gray',
          className,
        )}
      >
        <HeaderSubheader
          title={`${typeTitle} Gifting`}
          text={`Configure ${typeTitle} as gift`}
        />

        <EditInput
          title="Product Gifting"
          value={
            product?.freeGift?.isEligible
              ? `Marked as gift • ${(
                  product.freeGift?.stock ?? 0
                ).toLocaleString()} left`
              : 'Not a gift'
          }
          onEditClick={() => {
            handleModalOpen('productGiftingModal')
          }}
          errors={undefined}
          onCancel={() => {}}
          onEditSave={() => {}}
          editing={false}
          className={''}
        />
      </div>

      {product ? (
        <ProductGiftingModal
          open={modalOpen && modal === 'productGiftingModal'}
          closeModal={() => {
            handleModalClose()
          }}
          product={product}
          onSuccess={() => {
            refetch()
            handleModalClose()
          }}
        />
      ) : undefined}
    </>
  )
}
